import { config } from '@js/index';

export default class LV2StartScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LV2StartScene' });
  }

  preload() {}

  create() {
    this.cameras.main.fadeIn(1000, 255, 255, 255);

    this.add.sprite(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      'lv2_startBG',
    );

    this.lv2_truck = this.add.sprite(280, 156, 'lv2_truck').setOrigin(0).setVisible(true);

    this.characterAnim = this.add
      .sprite(335, 250, 'characterAnim')
      .setOrigin(0)
      .setVisible(true);

    this.anims.create({
      key: 'givelife',
      frames: this.anims.generateFrameNames('characterAnim', {
        start: 0,
        end: 50,
        zeroPad: 0,
        prefix: 'Character',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });
    this.characterAnim.play('givelife');

    this.wheelCapAnim = this.add
      .sprite(379, 442, 'wheelCapAnim')
      .setOrigin(0)
      .setVisible(true);
    this.wheelCapAnim2 = this.add
      .sprite(379 + 386, 442, 'wheelCapAnim')
      .setOrigin(0)
      .setVisible(true);

    this.anims.create({
      key: 'rollwheel',
      frames: this.anims.generateFrameNames('wheelCapAnim', {
        start: 0,
        end: 16,
        zeroPad: 0,
        prefix: 'WheelCap',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });
    this.wheelCapAnim.play('rollwheel');
    this.wheelCapAnim2.play('rollwheel');

    this.dustAnim = this.add.sprite(320, 310, 'dustAnim').setOrigin(0).setVisible(true);
    this.anims.create({
      key: 'dustflying',
      frames: this.anims.generateFrameNames('dustAnim', {
        start: 0,
        end: 32,
        zeroPad: 0,
        prefix: 'Dust',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });
    this.dustAnim.play('dustflying');

    this.maskImage = this.add
      .image(300.65 - 2.5, 243.48 - 2.5, 'lv2_truckMask')
      .setOrigin(0)
      .setVisible(true);
    this.wheels = this.add
      .sprite(372.46 - 2.5, 441.21 - 2.5, 'wheels')
      .setOrigin(0)
      .setVisible(true);

    const truckContainer = this.add.container(0, 0);
    truckContainer.add([
      this.lv2_truck,
      this.characterAnim,
      this.maskImage,
      this.wheels,
      this.wheelCapAnim,
      this.wheelCapAnim2,
      this.dustAnim,
    ]);

    config.audio.TruckHornL2StartScene = this.sound
      .add('TruckHornL2StartScene')
      .setVolume(0.1);
    this.time.delayedCall(1000, () => {
      config.audio.TruckHornL2StartScene.play();
    });

    config.audio.largetruckdriveoff = this.sound
      .add('large-truck-drive-off')
      .setVolume(0.1);
    config.audio.largetruckdriveoff.play();

    this.tweens.add({
      targets: config.audio.largetruckdriveoff,
      volume: 0,
      delay: 500,
      duration: 4500,
    });

    this.tweens.add({
      targets: truckContainer,
      y: { start: -10, to: 10, duration: 300, repeat: -1, yoyo: true },
      x: { start: 1000, to: -1000, duration: 4500, repeat: 0 },
    });

    this.time.delayedCall(3700, () => {
      this.cameras.main.fadeOut(1000, 255, 255, 255);
    });

    this.cameras.main.once('camerafadeoutcomplete', () => {
      this.scene.stop('LV2StartScene');
      this.scene.start('LV2GameScene');
    });
  }

  update() {}
}
